<template>
    <b-modal hide-footer title="Task" id="taskModal">
        <b-overlay :show="isSaving">
            <b-form>
                <b-row class="mb-3">
                    <b-col cols="12">
                        <label for="">Body</label>
                        <b-textarea max-rows="3" rows="2" v-model="form_data.body"></b-textarea>
                    </b-col>
                </b-row>

                <b-row class="mb-3">
                    <b-col cols="12">
                        <label for="">Task Type</label>
                        <b-form-select class="form-select" :options="typeOptions" v-model="form_data.type"></b-form-select>
                    </b-col>
                </b-row>

                <b-row class="mb-3" v-if="form_data.type == 'client_task'">
                    <b-col cols="12">
                        <label for="">User</label>
                        <vue-typeahead-bootstrap
                            :showOnFocus="true"
                            @hit="findUser($event)"
                            v-model="form_data.name_query"
                            :data="users"
                            :minMatchingChars="1"
                            v-show="users.length > 0"
                        />
                    </b-col>
                </b-row>
            </b-form>
            <div style="width: 100%;">
                <b-button @click="save" variant="success" class="ms-1" style="float: right;">Save</b-button>
                <b-button @click="$emit('exit')" style="float: right;">Cancel</b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
import _ from 'lodash'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
export default {
    props:{
        users:{
            default: function(){
                return [];
            }
        }
    },
    data:() => ({
        typeahead_query: '',
        isSaving: false,
        form_data:{
            body: '',
            type: null,
            due_date: null,
            name_query: '',
        },
        typeOptions:[
            { value: 'admin_task', text: 'Admin Task' },
            { value: 'client_task', text: 'Client Task' }
        ]
    }),
    components:{
        VueTypeaheadBootstrap,
    },
    computed:{},
    methods:{
        save(){
            this.$emit('saved', this.form_data);
        },
        findUser(string){
            if(this.users != null){
                //eslint-disable-next-line
                let obj = _.find(this.users, { name : string });
            }
        },
    },
    mounted(){},
}
</script>

<style>

</style>